module.exports = __webpack_public_path__ + "img/opet-infographic-11.e0d53dc5.jpg";